import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteModelType } from 'src/api/mutations';
import { getModelTypeList } from 'src/api/queries';
import { ConfirmDialog } from 'src/components/common';
import { useStyledSnackbar } from 'src/components/common/styled-components/styledSnackbars';

const DeleteModelTypeDialog = ({ modelType, navigate, open, setOpen }) => {
  const queryClient = useQueryClient();
  const { successSnackbar, errorSnackbar } = useStyledSnackbar();

  const mutation = useMutation({
    mutationFn: () => deleteModelType.func(modelType?.id),
    mutationKey: [deleteModelType.key],

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [getModelTypeList.key]
      });
      successSnackbar('Model type removed successfully.');
      setOpen(false);
      navigate('/dashboard/modeltypes');
    },

    onError: (err) => {
      errorSnackbar('Failed to remove model type.', err);
      setOpen(false);
    }
  });

  if (!modelType) return null;

  return (
    <ConfirmDialog
      open={open}
      onClose={() => setOpen(false)}
      onConfirm={() => mutation.mutate()}
      title={`Delete "${modelType.name}"?`}
      body="This action is permanent and cannot be undone."
      confirmLabel="Delete"
      confirmColor="error"
      loading={mutation.isPending}
    />
  );
};

export default DeleteModelTypeDialog;
